import styled from 'styled-components';
import { palette } from 'styled-tools';

import { fontSize, FontSizes, fontWeight, FontWeights, minWidth, Text } from '@calm-web/design-system';

import Image from '@/components/image/NextImage';

export const Container = styled.div<{
	handle: string;
}>`
	text-align: center;

	${minWidth('desktop')} {
		margin-right: ${p => (p.handle === 'acton' ? '60px' : '0')};
		display: inline-block;
	}
`;

export const AuthorImage = styled(Image)`
	height: 310px;
	width: 310px;
`;

export const Name = styled(Text).attrs({
	size: FontSizes.lg,
	color: 'black',
	weight: FontWeights.Light,
	el: 'p',
})<{
	handle: string;
}>`
	margin-block-start: 0 !important;
	margin-block-end: 0 !important;
	${p => (p.handle === 'tewy' ? 'position: relative; left: 15px;' : '')};
`;

export const Twitter = styled.a<{
	handle: string;
}>`
	color: ${palette('linkBlue')};
	${fontWeight(FontWeights.Medium)}
	${fontSize(FontSizes.lg)}
    ${p => (p.handle === 'tewy' ? 'position: relative; left: 15px;' : '')};
`;
